import React, { useState, useContext, useEffect, useRef } from "react";
// [CAPTCHA] import ReCAPTCHA from "react-google-recaptcha";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Grid,
  Typography,
  Modal,
  IconButton,
  Box,
} from "@material-ui/core";
import randomMC from "random-material-color";
import { ProductCard, TextField, Button } from "../components";
import {
  AddIcon,
  CloseIcon,
  SearchIcon,
  MessageIcon,
  PadlockIcon,
  SuccessIcon,
  SquareAlertIcon,
  WaitingForIcon,
  PopUpStatusFailed,
  PlayIcon,
  PlainIcon,
  ShowIcon,
} from "../icons";
import { ProductsContext, PathContext, AuthContext } from "../context";
import { modals } from "../constants";
import { onBlur, FormValidator, normalizeRutForApi } from "../helpers";
import { validarRUT } from "validar-rut";
import MaskedInput from "react-text-mask";
import { PASSWORD_REGEX, getPasswordStrength, getPasswordStrengthColor, getPasswordStrengthText, getVerificationMessage } from "../helpers/passwordValidator";
import Slider from "react-slick";

const resetPasswordRutValidator = new FormValidator([
  {
    field: "rut",
    method: "isEmpty",
    validWhen: false,
    message: "Ingrese su RUT.",
  },
  {
    field: "rut",
    method: (rut) => validarRUT(rut),
    validWhen: true,
    message: "El RUT ingresado no es válido.",
  },
]);

function RecoveryRutMask(props) {
  const { inputRef, ...other } = props;
  const { value } = other;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={
        value.length <= 8
          ? [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]/, /[kK0-9]/]
          : value.length <= 9
          ? [
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              "-",
              /[kK0-9]/,
              /[kK0-9]/,
            ]
          : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]+/g]
      }
      placeholderChar={"\u2000"}
      placeholder="Rut *"
      guide={false}
      showMask
    />
  );
}

export default function SampleScreen(props) {
  const {
    modalName,
    open,
    setModal,
    setModalName,
    message,
    modalError,
    popToTop,
    modalSubMessage,
    onClickSameLab,
    productToRequest,
    modalStep,
    setModalStep,
    onClickChangePassword,
    userToUpdate,
    status,
    isOrder,
    hideErrorWord,
  } = props;

  const classes = useStyles({ modalName, modalStep, ...props })();
  const [query, setQuery] = useState("");
  const [productsSelects, setProductsSelects] = useState([]);
  const { products, addProducts, deleteProduct, updateQuantity } =
    useContext(ProductsContext);
  const { setTab } = useContext(PathContext);
  const history = useHistory();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filter, setFilter] = useState(false);

  const [recoveryRut, setRecoveryRut] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [code, setCode] = useState("");
  const [errors, setErrors] = useState({});
  const [seeVideo, setSeeVideo] = useState(false);
  const { signOut, editProfile } = useContext(AuthContext);

  // [CAPTCHA] const [captchaValue, setCaptchaValue] = useState(null);
  // [CAPTCHA] const captchaRef = useRef(null);

  // [CAPTCHA]
  // const onCaptchaChange = (value) => {
  //   setCaptchaValue(value);
  // };

  let testLab = "Prueba";
  const validator2 = new FormValidator([
    {
      field: "code",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese codigo de confirmación.",
    },
    {
      field: "password",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese contraseña.",
    },
    {
      field: "password",
      method: (password) => PASSWORD_REGEX.test(password),
      validWhen: true,
      message: (password) => getVerificationMessage(password && password.password ? password.password : password),
    },
    {
      field: "confirm",
      method: "isEmpty",
      validWhen: false,
      message: "Confirme su contraseña.",
    },
    {
      field: "confirm",
      method: (confirm) => (confirm === password ? true : false),
      validWhen: true,
      message: "Las contraseñas no coinciden.",
    },
  ]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => {
      if (oldIndex === 3 && newIndex === 0) {
        setModal();
        setSeeVideo(false);
      }
    },
  };

  useEffect(() => {
    if (!modalStep) {
      setCode("");
      setPassword("");
      setConfirm("");
      // [CAPTCHA] setCaptchaValue(null);
    }
  }, [modalStep]);

  useEffect(() => {
    if (!open) {
      setRecoveryRut("");
      setErrors((prev) => {
        const next = { ...prev };
        delete next.rut;
        return next;
      });
    }
  }, [open]);

  const onSelectProduct = ({ product }) => {
    if (productsSelects.length) {
      const element = productsSelects.find((el) => el._id === product._id);
      // console.log('No esta vacio')
      if (element) {
        let aux = productsSelects.filter((el) => el._id !== product._id);
        // console.log('Lo encuentra y lo elimina', aux)
        setProductsSelects(aux);
      } else {
        let aux = productsSelects;
        aux.push({ ...product, isSelect: !product.isSelect });
        //console.log('No lo encuentra y lo agrega', aux)
        setProductsSelects(aux);
      }
    } else {
      setProductsSelects([{ ...product, isSelect: !product.isSelect }]);
      // console.log('si esta vacio y lo agrega', [{...product, isSelect:!product.isSelect}])
    }
  };

  const filterList = (value) => {
    if (value === "") {
      setFilter(false);
    }
    setQuery(value);
    setFilteredProducts(
      products.filter(
        (product, index) =>
          !product.isSelect &&
          product.assigned - product.used !== 0 &&
          product.name.toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilter(true);
  };

  const onResetPassword = async (e) => {
    if (!modalStep) {
      const validationRut = resetPasswordRutValidator.validate({
        rut: recoveryRut,
      });
      setErrors(validationRut);
      if (validationRut.isValid) {
        onClickChangePassword({ rut: normalizeRutForApi(recoveryRut) });
      }
      return;
    } else {
      const validation = validator2.validate({ code, password, confirm });
      setErrors(validation);
      if (validation.isValid) {
        onClickChangePassword({ token: code, password });
      }
      return;
    }
  };

  const onAddProducts = async () => {
    // console.log('productos a agregar', productsSelects);
    await addProducts(productsSelects);
    setProductsSelects([]);
  };

  const renderModal = () => {
    switch (modalName) {
      //SAMPLE SUMMARY POP UP
      case modals[0]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid
              item
              sm={12}
              xs={12}
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid item xs={12} md={12} className={classes.modalTitle1}>
                  <Grid container>
                    <Grid
                      container
                      item
                      xs={12}
                      style={{ position: "relative" }}
                    >
                      <Typography
                        className={classes.modalTitle}
                        component="h1"
                        variant="h1"
                        align="center"
                      >
                        Resumen de muestras
                        <IconButton onClick={() => setModal()}>
                          <CloseIcon />
                        </IconButton>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid className={classes.scrollList} container>
                  {products
                    .filter((product) => product.isSelect)
                    .map((product, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        key={index}
                        style={{
                          marginBottom:
                            products.length - 1 === index ? 100 : 25,
                          height: "fit-content",
                        }}
                      >
                        <ProductCard
                          product={product}
                          onClickDelete={() => deleteProduct(product)}
                          add1={() =>
                            updateQuantity(
                              product,
                              product.quantityToAssign + 1
                            )
                          }
                          delete1={() =>
                            updateQuantity(
                              product,
                              product.quantityToAssign - 1
                            )
                          }
                          modal
                        />
                      </Grid>
                    ))}
                </Grid>
                <Grid
                  container
                  justify="center"
                  className={`${classes.button} ${classes.btnModal}`}
                >
                  <Button onClick={(e) => setModalName(modals[1])}>
                    <AddIcon /> AGREGAR OTRAS
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP TO ADD MORE SAMPLES
      case modals[1]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid
              item
              sm={12}
              xs={12}
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid item xs={12} md={12} className={classes.modalTitle1}>
                  <Grid container>
                    <Grid
                      container
                      item
                      xs={12}
                      style={{ position: "relative" }}
                    >
                      <Typography
                        className={classes.modalTitle}
                        component="h1"
                        variant="h1"
                        align="center"
                      >
                        Botiquín
                        <IconButton onClick={() => setModal()}>
                          <CloseIcon />
                        </IconButton>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  className={classes.containerTextField}
                >
                  <TextField
                    type={"text"}
                    name={"query"}
                    value={query}
                    placeholder="¿Qué estás buscando?"
                    fontWeight="bold"
                    style={{ height: 43, justifyContent: "flex-end" }}
                    containerStyle={{ height: "fit-contain" }}
                    showIcon
                    iconComponent={() => <SearchIcon />}
                    onClickIcon={() => {}}
                    onChange={(e) => filterList(e.target.value)}
                  />
                </Grid>
                <Grid
                  container
                  className={`${classes.scrollList} ${classes.scrollPopUp2}`}
                >
                  {!filter &&
                    products
                      .filter(
                        (product) =>
                          !product.isSelect &&
                          product.assigned - product.used !== 0
                      )
                      .map((product, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          key={index}
                          style={{ marginBottom: 25 }}
                        >
                          <ProductCard
                            popUp
                            viewList={true}
                            product={product}
                            onClickSelect={() => onSelectProduct({ product })}
                          />
                        </Grid>
                      ))}
                  {filter &&
                    filteredProducts.map((product, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        key={index}
                        style={{ marginBottom: 25 }}
                      >
                        <ProductCard
                          popUp
                          viewList={true}
                          product={product}
                          onClickSelect={() => onSelectProduct({ product })}
                        />
                      </Grid>
                    ))}
                </Grid>
                <Grid
                  container
                  justify="center"
                  className={`${classes.button} ${classes.btnModal}  ${classes.addMore}`}
                >
                  <Button onClick={onAddProducts}>
                    <AddIcon style={{ margin: "0 10px 0 0" }} /> AGREGAR{" "}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP API RESPONSE
      case modals[2]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid item sm={12} xs={12} className={classes.modal3}>
              <Grid
                item
                sm={12}
                xs={12}
                container
                justify="center"
                alignItems={"center"}
                style={{ margin: "30px 0 0 0" }}
              >
                {modalError ? <PopUpStatusFailed /> : <SuccessIcon />}
              </Grid>
              <Typography align="center" color="primary">
                {!modalError ? message : hideErrorWord ? null : "Error"}
              </Typography>
              <Typography align="center" color="secondary">
                {modalError ? message : modalSubMessage}
              </Typography>
              <Button
                className={classes.buttonApiResponse}
                fullWidth
                onClick={() => {
                  setModal();
                  if (popToTop) {
                    history.push({ pathname: popToTop });
                  }
                  if (userToUpdate) {
                    editProfile({ user: userToUpdate.user });
                  }
                }}
              >
                Aceptar
              </Button>
            </Grid>
          </Grid>
        );
      }
      //POP TO REQUEST MORE SAMPLES
      case modals[3]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid item sm={12} xs={12}>
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "relative",
                    padding: "0 12px",
                    height: 50,
                  }}
                >
                  <Grid container>
                    <Grid
                      container
                      justify="flex-end"
                      item
                      xs={12}
                      style={{ position: "relative" }}
                    >
                      <IconButton onClick={() => setModal()}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid
                    className={classes.requestSample}
                    container
                    justify="center"
                  >
                    <Grid item sm={10} xs={10}>
                      <img src={productToRequest.logo} alt="" width="100%" />
                      <Box>
                        <Typography
                          variant="body2"
                          align="center"
                          color="primary"
                          style={{ fontWeight: "bold" }}
                        >
                          {productToRequest.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          align="center"
                          color="primary"
                          style={{ lineHeight: "1.1" }}
                        >
                          {productToRequest.presentation}
                        </Typography>
                        <Typography
                          variant="body2"
                          align="center"
                          color="primary"
                          style={{ lineHeight: "1.1" }}
                        >
                          {productToRequest.concentration}
                        </Typography>
                      </Box>
                      <Typography
                        align="center"
                        color="primary"
                        style={{ margin: "12px auto 18px auto" }}
                      >
                        ¿Confirma que desea solicitar esta muestra?
                      </Typography>
                    </Grid>
                    <Grid container justifyContent="center" item xs>
                      <Button
                        fullWidth
                        onClick={() => onClickSameLab(productToRequest)}
                      >
                        ACEPTAR
                      </Button>
                      {/* <Button fullWidth onClick={() => { history.push({ pathname: "/request", state: { productToRequest } }); setTab({ index: 1 }); }}>AGREGAR OTROS PRODUCTOS</Button> */}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP TO DISPLAY PRODUCT IMAGE
      case modals[4]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid
              item
              sm={12}
              xs={12}
              style={{ position: "relative", width: "100%" }}
            >
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "relative",
                    padding: "0 12px",
                    height: 50,
                  }}
                >
                  <Grid container>
                    <Grid
                      container
                      justify="flex-end"
                      item
                      xs={12}
                      style={{ position: "relative" }}
                    >
                      <IconButton onClick={() => setModal()}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid
                    className={classes.requestSample}
                    container
                    justify="center"
                  >
                    <Grid item sm={10} xs={10}>
                      <img src={productToRequest.logo} alt="" width="100%" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP CONTACT LAB
      case modals[5]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid
              item
              sm={12}
              xs={12}
              style={{ position: "relative", width: "100%" }}
            >
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "relative",
                    padding: "0 12px",
                    height: 50,
                  }}
                >
                  <Grid container>
                    <Grid
                      container
                      justify="flex-end"
                      item
                      xs={12}
                      style={{ position: "relative" }}
                    >
                      <IconButton onClick={() => setModal()}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid
                    className={classes.contactLab}
                    container
                    justify="center"
                    direction="column"
                    alignItems="center"
                  >
                    <div>
                      <Typography>{testLab.charAt(0)}</Typography>
                    </div>
                    <div>
                      <Typography align="center" color="secondary">
                        laboratorio
                      </Typography>
                    </div>
                    <div>
                      <Typography align="center" color="primary">
                        {testLab}
                      </Typography>
                    </div>
                    <Grid container justify="space-around" item sm={6} xs={8}>
                      <Button
                        fullWidth
                        onClick={() => {
                          history.push({ pathname: "/request" });
                          setTab({ index: 1 });
                        }}
                      >
                        CONTACTAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP CLOSE SESION
      case modals[6]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid
              item
              sm={12}
              xs={12}
              style={{ position: "relative", width: "100%" }}
            >
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "relative",
                    padding: "0 12px",
                    height: 50,
                  }}
                >
                  <Grid container>
                    <Grid
                      container
                      justify="flex-end"
                      item
                      xs={12}
                      style={{ position: "relative" }}
                    >
                      <IconButton onClick={() => setModal()}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  container
                  justify="center"
                  alignItems="center"
                  style={{ margin: "0 0 30px 0" }}
                >
                  <SquareAlertIcon />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid
                    className={classes.closeSesion}
                    container
                    justify="center"
                    direction="column"
                    alignItems="center"
                  >
                    <div>
                      <Typography align="center" color="primary">
                        ¿Está seguro/a
                        <br /> que desea cerrar
                        <br /> su sesión?
                      </Typography>
                    </div>
                    <Grid container justify="space-around" item sm={12} xs={8}>
                      <Button
                        className={classes.buttonApiResponse}
                        onClick={() => signOut()}
                      >
                        ACEPTAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP RESET PASSWORD
      case modals[7]: {
        return (
          <Grid item sm={12} xs={12} className={classes.paperModal}>
            <IconButton
              onClick={() => {
                setRecoveryRut("");
                setModal();
                if (setModalStep) setModalStep(0);
              }}
              style={{ position: "absolute", right: 13, top: 11 }}
            >
              <CloseIcon />
            </IconButton>
            <Grid container justify="center">
              <Grid
                item
                sm={12}
                xs={12}
                container
                justify="center"
                alignItems="center"
                style={{ margin: "0 0 30px 0" }}
              >
                {!modalStep ? <MessageIcon /> : <PadlockIcon />}
              </Grid>
              <Grid item sm={12} xs={12} className={classes.modal7Title}>
                {!modalStep ? (
                  <Typography component="h1" variant="h1" align="center">
                    Ingresa tu RUT <br />
                    para recuperar tu <br />
                    contraseña
                  </Typography>
                ) : (
                  <Typography component="h1" variant="h1" align="center">
                    Ingresa el codigo <br />
                    que te hemos enviado
                    <br />a tu correo
                  </Typography>
                )}
              </Grid>
              <Grid item sm={12} xs={12} className={classes.modal7Fields}>
                {!modalStep ? (
                  <>
                  <TextField
                    name={"rut"}
                    value={recoveryRut}
                    onChange={async (e) => {
                      setRecoveryRut(e.target.value);
                      if (e.target.value.length >= 8) {
                        setErrors(
                          await onBlur({
                            field: "rut",
                            value: e.target.value,
                            validator: resetPasswordRutValidator,
                            errors,
                          })
                        );
                      }
                    }}
                    placeholder="RUT *"
                    onBlur={async () =>
                      setErrors(
                        await onBlur({
                          field: "rut",
                          value: recoveryRut,
                          validator: resetPasswordRutValidator,
                          errors,
                        })
                      )
                    }
                    error={errors.rut && errors.rut.isInvalid}
                    helperText={errors.rut ? errors.rut.message : ""}
                    inputComponent={RecoveryRutMask}
                  />
                  {/* [CAPTCHA]
                  <Grid item sm={12} xs={12} container justify="center" style={{ marginTop: 20 }}>
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey="6Lcz_FkrAAAAAO9wXBX9Ft6ls16EaYzC6hKhwCBr"
                      onChange={onCaptchaChange}
                    />
                  </Grid>
                  */}
                  </>
                ) : (
                  <>
                    <TextField
                      name={"Code"}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="Ingresa el codigo de validación"
                      value={code}
                      onBlur={async () =>
                        setErrors(
                          await onBlur({
                            field: "code",
                            value: code,
                            validator: validator2,
                            errors,
                          })
                        )
                      }
                      error={errors.code && errors.code.isInvalid}
                      helperText={errors.code ? errors.code.message : ""}
                    />
                    <TextField
                      type={showPassword ? "text" : "password"}
                      name={"password"}
                      value={password}
                      iconComponent={() => <ShowIcon />}
                      onClickIcon={() => setShowPassword(!showPassword)}
                      onChange={async (e) => {
                        setPassword(e.target.value);
                        setErrors(
                          await onBlur({
                            field: "password",
                            value: e.target.value,
                            validator: validator2,
                            errors,
                          })
                        );
                      }}
                      placeholder="Contraseña *"
                      onBlur={async () =>
                        setErrors(
                          await onBlur({
                            field: "password",
                            value: password,
                            validator: validator2,
                            errors,
                          })
                        )
                      }
                      error={errors.password && errors.password.isInvalid}
                      helperText={
                        errors.password ? errors.password.message : ""
                      }
                    />
                    {password && (
                      <Box style={{ width: '100%', marginTop: '5px' }}>
                         <div style={{
                            height: '5px',
                            width: '100%',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '5px',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              height: '100%',
                              width: `${(getPasswordStrength(password) / 4) * 100}%`,
                              backgroundColor: getPasswordStrengthColor(getPasswordStrength(password)),
                              transition: 'width 0.3s ease-in-out'
                            }} />
                          </div>
                          <Typography variant="caption" style={{ color: getPasswordStrengthColor(getPasswordStrength(password)) }}>
                            Fortaleza: {getPasswordStrengthText(getPasswordStrength(password))}
                          </Typography>
                      </Box>
                    )}
                    <TextField
                      name={"confirm"}
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      value={confirm}
                      iconComponent={() => <ShowIcon />}
                      onClickIcon={() => setShowPassword(!showPassword)}
                      onChange={async (e) => {
                        setConfirm(e.target.value);
                        setErrors(
                          await onBlur({
                            field: "confirm",
                            value: e.target.value,
                            validator: validator2,
                            errors,
                          })
                        );
                      }}
                      placeholder="Confirmar contraseña *"
                      onBlur={async () =>
                        setErrors(
                          await onBlur({
                            field: "confirm",
                            value: confirm,
                            validator: validator2,
                            errors,
                          })
                        )
                      }
                      error={errors.confirm && errors.confirm.isInvalid}
                      helperText={errors.confirm ? errors.confirm.message : ""}
                    />
                  </>
                )}
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                item
                sm={12}
                xs={12}
              >
                <Button
                  fullWidth
                  className={classes.button}
                  onClick={onResetPassword}
                  disabled={false} /* [CAPTCHA] disabled={!modalStep && !captchaValue} */
                >
                  {modalStep ? "Enviar" : "Aceptar"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP HISTORY STATUS
      case modals[8]: {
        return (
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            item
            xs={12}
            className={classes.paperModal}
          >
            <Grid
              item
              sm={12}
              xs={12}
              style={{ position: "relative", width: "100%" }}
            >
              <Grid container style={{ height: "100%", display: "block" }}>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  container
                  justify="center"
                  alignItems="center"
                  style={{ margin: "43px 0 30px 0" }}
                >
                  {status === 0 ? (
                    <WaitingForIcon />
                  ) : status === 1 ? (
                    <SuccessIcon />
                  ) : status === 2 ? (
                    <PopUpStatusFailed />
                  ) : status === 3 ? (
                    <PlainIcon />
                  ) : (
                    <PopUpStatusFailed />
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid
                    className={classes.closeSesion}
                    container
                    justify="center"
                    direction="column"
                    alignItems="center"
                  >
                    <div>
                      {status === 0 || status === "66182a197b4df03548c40404" ? (
                        isOrder ? (
                          <Typography align="center" color="primary">
                            Esperando la <br /> aprobación del <br />{" "}
                            Laboratorio
                          </Typography>
                        ) : (
                          <Typography align="center" color="primary">
                            En espera por <br /> aprobación del <br /> paciente
                          </Typography>
                        )
                      ) : status === 1 ||
                        status === "66182a497b4df03548c40405" ? (
                        isOrder ? (
                          <Typography align="center" color="primary">
                            Su Solicitud <br /> ha sido exitosa
                          </Typography>
                        ) : (
                          <Typography align="center" color="primary">
                            Asignación ha sido <br /> entregada exitosamente
                          </Typography>
                        )
                      ) : status === 2 ||
                        status === "661829ad7b4df03548c40400" ? (
                        isOrder ? (
                          <Typography align="center" color="primary">
                            Su solicitud <br /> ha sido fallida
                          </Typography>
                        ) : (
                          <Typography align="center" color="primary">
                            Fallido en entrega
                          </Typography>
                        )
                      ) : status === 3 ||
                        status === "66182a037b4df03548c40403" ? (
                        <Typography align="center" color="primary">
                          Su asignación está <br /> en camino
                        </Typography>
                      ) : status === "661829e67b4df03548c40402" ? (
                        <Typography align="center" color="primary">
                          En <br /> preparación
                        </Typography>
                      ) : (
                        <Typography align="center" color="primary">
                          Rechazado por el <br /> paciente
                        </Typography>
                      )}
                    </div>
                    <Grid container justify="space-around" item sm={12} xs={8}>
                      <Button fullWidth onClick={() => setModal()}>
                        ACEPTAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
      //POP UP TUTORIAL
      // case modals[9]: {
      //   return (
      //     <Grid
      //       container
      //       direction="column"
      //       justify="flex-start"
      //       alignItems="center"
      //       item
      //       xs={12}
      //       className={classes.paperModal}
      //     >
      //       <Grid
      //         item
      //         sm={12}
      //         xs={12}
      //         style={{ position: "relative", width: "100%" }}
      //       >
      //         <div>
      //           <Slider {...settings} className={classes.slider}>
      //             <div>
      //               <Grid
      //                 container
      //                 justify="center"
      //                 alignItems="center"
      //                 direction={"column"}
      //                 className={classes.tutorialSlider}
      //               >
      //                 <img
      //                   src={"../../assets/tutorial-1.svg"}
      //                   alt="tutorial-1"
      //                 />
      //                 <Typography align="center">
      //                   <br />
      //                   <br />
      //                   ¡Bienvenido al primer botiquín virtual de muestras
      //                   médicas!
      //                 </Typography>
      //                 <Typography align="center">
      //                   <br />
      //                   El botiquín de Unio es un servicio exclusivo para
      //                   médicos donde ponemos a su disposición todas las
      //                   muestras médicas en un mismo lugar.
      //                 </Typography>
      //               </Grid>
      //             </div>
      //             <div>
      //               <Grid
      //                 container
      //                 justify="center"
      //                 alignItems="center"
      //                 direction={"column"}
      //                 className={classes.tutorialSlider}
      //               >
      //                 <img
      //                   src={"../../assets/tutorial-2.svg"}
      //                   alt="tutorial-1"
      //                 />
      //                 <Typography align="center">
      //                   <br />
      //                   <br />
      //                   ¡Muestras médicas siempre a la mano!
      //                 </Typography>
      //                 <Typography align="center">
      //                   <br />
      //                   En Unio, usted podrá enviar muestras médicas a sus
      //                   pacientes para inicio o mantención de tratamiento 24/7.
      //                   <br />
      //                   <br />
      //                   Elija el producto que quiere entregar, informe al
      //                   paciente que lo recibirá y nosotros nos encargamos de
      //                   hacerla llegar, gratuitamente
      //                 </Typography>
      //               </Grid>
      //             </div>
      //             <div>
      //               <Grid
      //                 container
      //                 justify="center"
      //                 alignItems="center"
      //                 direction={"column"}
      //                 className={classes.tutorialSlider}
      //               >
      //                 <img
      //                   src={"../../assets/tutorial-3.svg"}
      //                   alt="tutorial-1"
      //                 />
      //                 <Typography align="center">
      //                   <br />
      //                   <br />
      //                   ¡Seguridad en la entrega!
      //                 </Typography>
      //                 <Typography align="center">
      //                   <br />
      //                   Garantizamos cumplimiento de calidad, temperatura y
      //                   puntualidad en la entrega.
      //                   <br />
      //                   <br />
      //                   Haga seguimiento de entrega de los tratamientos a sus
      //                   pacientes a través de Unio.
      //                 </Typography>
      //               </Grid>
      //             </div>
      //             <div>
      //               <Grid
      //                 container
      //                 justify="center"
      //                 alignItems="center"
      //                 direction={"column"}
      //                 className={classes.tutorialSlider}
      //               >
      //                 {!seeVideo ? (
      //                   <>
      //                     <img
      //                       src={"../../assets/tutorial-4.svg"}
      //                       alt="tutorial-1"
      //                     />
      //                     <Typography align="center">
      //                       <br />
      //                       <br />
      //                       ¡Te mostramos como funciona!
      //                     </Typography>
      //                     <Typography align="center">
      //                       <br />
      //                       Haz click para ver el tutorial
      //                     </Typography>
      //                     <IconButton
      //                       style={{ margin: "15px 0 0 0" }}
      //                       onClick={() => setSeeVideo(true)}
      //                     >
      //                       <PlayIcon />
      //                     </IconButton>
      //                   </>
      //                 ) : (
      //                   <video controls>
      //                     <source
      //                       src="../../unio-tutorial.mp4"
      //                       type="video/mp4"
      //                     />
      //                   </video>
      //                 )}
      //               </Grid>
      //             </div>
      //           </Slider>
      //           <Button
      //             onClick={() => setModal()}
      //             className={classes.buttonSkip}
      //           >
      //             SALTAR
      //           </Button>
      //         </div>
      //       </Grid>
      //     </Grid>
      //   );
      // }
      default:
        return null;
    }
  };

  return (
    <Modal
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
      }}
      open={open}
    >
      <>{renderModal()}</>
    </Modal>
  );
}

const useStyles = ({ modalName, modalStep, ...props }) =>
  makeStyles((theme) => ({
    paperModal: {
      position: "absolute",
      width: modalName === modals[9] ? "100vw" : "90%",
      top: modalName === modals[9] ? 0 : "unset",
      bottom: modalName === modals[9] ? 0 : "unset",
      left: modalName === modals[9] ? 0 : "unset",
      right: modalName === modals[9] ? 0 : "unset",
      overflowY: "scroll",
      height:
        modalName === modals[0] || modalName === modals[1]
          ? "90%"
          : modalName === modals[9]
          ? "100vh"
          : "unset",
      backgroundColor: "#FFF",
      boxShadow: theme.shadows[5],
      borderRadius: modalName === modals[9] ? 0 : "45px",
      padding:
        modalName === modals[3]
          ? "12px 12px 60px 12px"
          : modalName === modals[7]
          ? 30
          : "12px",
      outline: "none",
      [theme.breakpoints.up("md")]: {
        width:
          modalName === modals[2] ||
          modalName === modals[3] ||
          modalName === modals[6] ||
          modalName === modals[7] ||
          modalName === modals[8]
            ? 324
            : modalName === modals[9]
            ? "100vw"
            : "40%",
      },
      "&::-webkit-scrollbar": {
        width: "1px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        borderRadius: "10px",
      },
    },
    button: {
      "& button": {
        width: "100%",
        color: "#FFF",
        textAlign: "center",
        height: "100%",
        padding: "0 18px",
        borderRadius: modalName === modals[7] ? 30 : 20.5,
        fontSize: modalName === modals[7] ? "1.313rem" : "0.813rem",
        fontWeight: modalName === modals[7] ? "700" : "bold",
        display: "flex",
        justifyContent: modalName === modals[7] ? "center" : "space-between",
        alignItems: "center",
      },
    },
    btnModal: {
      "& button": {
        height: 40,
        justifyContent: "space-evenly",
        width: "100%",
        padding: "0 70px",
        [theme.breakpoints.up("md")]: {
          bottom: "unset",
          width: "100%",
        },
      },
    },
    modalTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      padding: "25px 0 0 0",
      "& button": {
        padding: 0,
      },
    },
    modalTitle1: {
      position: "relative",
      padding: "0 12px",
      height: "8%",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        height: "10%",
      },
    },
    containerTextField: {
      margin: "4% 0",
      [theme.breakpoints.up("md")]: {
        padding: "0 25px",
      },
    },
    modal3: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      "& p:nth-child(2)": {
        fontSize: "1.125rem",
        fontWeight: "bold",
        lineHeight: "1.375rem",
        margin: "30px 0 0 0",
      },
      "& p:nth-child(3)": {
        fontSize: "0.875rem",
        lineHeight: "1.063rem",
        fontWeight: "normal",
        margin: "23px 0 43px 0",
      },
      "& button": {
        backgroundColor: theme.palette.secondary.main,
        color: "#FFF",
        height: 41,
        borderRadius: 20.5,
        width: 213,
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
        fontWeight: "bold",
        margin: "0 0 50px 0",
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
    },
    requestSample: {
      "& > div": {
        "& > p": {
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          margin: "40px 0",
        },
        "& button:nth-child(1)": {
          backgroundColor: theme.palette.primary.main,
          width: "48%",
          height: 41,
          borderRadius: 20.5,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          color: "#FFF",
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
        "& button:nth-child(2)": {
          backgroundColor: theme.palette.secondary.main,
          width: "48%",
          height: 41,
          borderRadius: 20.5,
          fontSize: ".7rem",
          lineHeight: "1rem",
          fontWeight: "bold",
          color: "#FFF",
          "&:hover": {
            backgroundColor: theme.palette.secondary.main,
          },
        },
      },
    },
    contactLab: {
      "& div:nth-child(1)": {
        width: "16%",
        height: 50,
        borderRadius: 15,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: randomMC.getColor({ shades: ["100", "200"] }),
        "& p": {
          fontSize: "2rem",
          color: "#FFF",
          fontWeight: "bold",
        },
      },
      "& div:nth-child(2)": {
        "& p": {
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          fontWeight: "bold",
          margin: "35px 0 8px 0",
        },
      },
      "& div:nth-child(3)": {
        "& p": {
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          margin: "0 0 43px 0",
        },
      },
      "& div:nth-child(4)": {
        "& button": {
          backgroundColor: theme.palette.secondary.main,
          color: "#FFF",
          borderRadius: 20.5,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          margin: "0 0 44px 0",
          "&:hover": {
            backgroundColor: theme.palette.secondary.main,
          },
        },
      },
    },
    closeSesion: {
      "& div:nth-child(1)": {
        "& p": {
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          margin: "0 0 43px 0",
        },
      },
      "& div:nth-child(2)": {
        "& button": {
          backgroundColor: theme.palette.secondary.main,
          color: "#FFF",
          borderRadius: 20.5,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          margin: "0 0 44px 0",
          [theme.breakpoints.up("md")]: {
            width: 213,
          },
          "&:hover": {
            backgroundColor: theme.palette.secondary.main,
          },
        },
      },
    },
    scrollList: {
      margin: "10px 0 0 0",
      height: "80%",
      overflowY: "scroll",
      display: "block",
      [theme.breakpoints.up("md")]: {
        margin: "5% 0 0 0",
        padding: "0 25px",
      },
      "&::-webkit-scrollbar": {
        width: "1px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        borderRadius: "10px",
      },
    },
    scrollPopUp2: {
      height: "70%",
      [theme.breakpoints.up("md")]: {
        height: "65%",
      },
    },
    addMore: {
      [theme.breakpoints.up("md")]: {
        display: "block",
        "& button": {
          justifyContent: "center",
        },
      },
    },
    modal7Title: {
      "& > h1": {
        [theme.breakpoints.up("md")]: {
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
        },
      },
    },
    modal7Fields: {
      "& > div": {
        margin: !modalStep ? "36px 0 31px" : "20px 0",
        [theme.breakpoints.up("md")]: {
          margin: !modalStep ? "20px 0 25px" : "20px 0",
        },
      },
    },
    buttonApiResponse: {
      [theme.breakpoints.up("md")]: {
        width: 213,
      },
    },
    slider: {
      margin: "0 0 60px 0",
      "& > ul": {
        bottom: "-60px",
        "& li": {
          "& button": {
            "&:before": {
              border: `1pt solid ${theme.palette.secondary.main}`,
              color: "transparent",
              borderRadius: "50%",
              width: 8,
              height: 8,
              fontSize: 0,
              lineHeight: 0,
              opacity: 1,
            },
          },
        },
        "& .slick-active": {
          "& button": {
            "&:before": {
              backgroundColor: theme.palette.secondary.main,
              opacity: 1,
            },
          },
        },
      },
    },
    tutorialSlider: {
      paddingTop: 65,
      "& img": {
        width: "60%",
        [theme.breakpoints.up("md")]: {
          width: "unset",
        },
      },
      "& > p:nth-child(2)": {
        margin: "0px 47px",
        fontWeight: "bold",
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
        color: theme.palette.primary.main,
      },
      "& > p:nth-child(3)": {
        margin: "0px 47px 10px",
        fontWeight: "normal",
        fontSize: "0.875rem",
        lineHeight: "1.063rem",
        color: theme.palette.secondary.main,
      },
      "& > video": {
        width: "100%",
        height: "auto",
        [theme.breakpoints.up("md")]: {
          width: "15%",
        },
      },
    },
    buttonSkip: {
      position: "absolute",
      height: "23px!important",
      top: "2%",
      right: "2%",
      border: "1px solid #2196C0",
      boxSizing: "border-box",
      borderRadius: 25,
      width: "59px!important",
      backgroundColor: "transparent!important",
      fontSize: "0.75rem!important",
      lineHeight: "1rem!important",
      fontWeight: "500!important",
      color: `${theme.palette.secondary.main}!important`,
      "&:hover": {
        backgroundColor: "transparent!important",
      },
    },
  }));
